import { render, staticRenderFns } from "./help3.vue?vue&type=template&id=0422706d&scoped=true"
import script from "./help3.vue?vue&type=script&lang=js"
export * from "./help3.vue?vue&type=script&lang=js"
import style0 from "./help3.vue?vue&type=style&index=0&id=0422706d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0422706d",
  null
  
)

export default component.exports